const baseNewsletterRequestUrl =
  "https://klusloods.us18.list-manage.com/subscribe/post-json?u=e2953e97c82b5390683028c78&id=25cbd195e3&f_id=00bcf7e0f0&c=?";
const professionalNewsletterRequestUrl =
  "https://klusloods.us18.list-manage.com/subscribe/post-json?u=e2953e97c82b5390683028c78&id=25cbd195e3&f_id=00a3f7e0f0&c=?";
let newsletterFormFirstStep = document.querySelectorAll(
  ".js-newsletter-form-first-step",
);
if (newsletterFormFirstStep) {
  newsletterFormFirstStep.forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      let currentEmail = this.querySelector(
        'input[ name="contact[email]"]',
      ).value;
      let baseFormEmail = document.querySelector(
        '#newLetterFormModalProfessionalAndBase form input[name="email"]',
      );
      if (baseFormEmail) {
        baseFormEmail.value = currentEmail;
      }
      if (this.querySelector("[data-fancybox]")) {
        this.querySelector("[data-fancybox]").click();
      }
    });
  });
}
let newsletterProfessionalFormFirstStep = document.querySelectorAll(
  ".js-newsletter-professional-form-first-step",
);
if (newsletterProfessionalFormFirstStep) {
  newsletterProfessionalFormFirstStep.forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      let currentEmail = this.querySelector(
        'input[ name="contact[email]"]',
      ).value;
      let baseFormEmail = document.querySelector(
        '#newLetterFormModalProfessional form input[name="email"]',
      );
      if (baseFormEmail) {
        baseFormEmail.value = currentEmail;
      }
      if (this.querySelector("[data-fancybox]")) {
        this.querySelector("[data-fancybox]").click();
      }
    });
  });
}
let newLetterProfessionalAndBaseForm = document.querySelector(
  "#newLetterFormModalProfessionalAndBase form",
);
if (newLetterProfessionalAndBaseForm) {
  newLetterProfessionalAndBaseForm.addEventListener("submit", function (e) {
    e.preventDefault();
    newsletterProfessionalAndBaseFormValidation(this);
  });
}
let newLetterProfessionalForm = document.querySelector(
  "#newLetterFormModalProfessional form",
);
if (newLetterProfessionalForm) {
  newLetterProfessionalForm.addEventListener("submit", function (e) {
    e.preventDefault();
    newsletterProfessionalFormValidation(this);
  });
}

function newsletterProfessionalAndBaseFormValidation(form) {
  let currentEmail = form.querySelector('input[name="email"]');
  let currentFirstName = form.querySelector('input[name="first_name"]');
  let currentLastName = form.querySelector('input[name="last_name"]');
  let currentCompanyName = form.querySelector('input[name="company_name"]');
  let currentCompanyType = form.querySelector('select[name="company_type"]');
  let currentPhone = form.querySelector('input[name="phone"]');
  let professionalFormCheckbox = form.querySelector(
    'input[name="professional_form"]',
  );
  let allowNewsletterCheckbox = form.querySelector(
    'input[name="allow_newsletter"]',
  );
  let allowProfessionalNewsletterCheckbox = form.querySelector(
    'input[name="allow_professional_newsletter"]',
  );
  let allowUseDataCheckbox = form.querySelector('input[name="allow_use_data"]');
  let validation = true;

  if (currentEmail.value == "") {
    validation = false;
    if (currentEmail.closest(".form-group-input")) {
      currentEmail.closest(".form-group-input").classList.add("hasError");
    }
    if (currentEmail.closest(".wrapper-inputs__item")) {
      currentEmail.closest(".wrapper-inputs__item").classList.add("hasError");
      if (
        currentEmail
          .closest(".wrapper-inputs__item")
          .querySelector(".error-message")
      ) {
        currentEmail
          .closest(".wrapper-inputs__item")
          .querySelector(".error-message").innerHTML =
          window.errors.required_error;
      }
    }
  } else {
    if (currentEmail.closest(".form-group-input")) {
      currentEmail.closest(".form-group-input").classList.remove("hasError");
    }
    if (currentEmail.closest(".wrapper-inputs__item")) {
      currentEmail
        .closest(".wrapper-inputs__item")
        .classList.remove("hasError");
    }
  }
  if (validateEmail(currentEmail.value)) {
    if (currentEmail.closest(".form-group-input")) {
      currentEmail.closest(".form-group-input").classList.remove("hasError");
    }
    if (currentEmail.closest(".wrapper-inputs__item")) {
      currentEmail
        .closest(".wrapper-inputs__item")
        .classList.remove("hasError");
    }
  } else {
    validation = false;
    if (currentEmail.closest(".form-group-input")) {
      currentEmail.closest(".form-group-input").classList.add("hasError");
    }
    if (currentEmail.closest(".wrapper-inputs__item")) {
      currentEmail.closest(".wrapper-inputs__item").classList.add("hasError");
      if (
        currentEmail
          .closest(".wrapper-inputs__item")
          .querySelector(".error-message")
      ) {
        currentEmail
          .closest(".wrapper-inputs__item")
          .querySelector(".error-message").innerHTML =
          window.errors.email_error;
      }
    }
  }
  if (currentPhone.value != "") {
    if (validatePhone(currentPhone.value)) {
      if (currentPhone.value.length < 5) {
        validation = false;
        if (currentPhone.closest(".form-group-input")) {
          currentPhone.closest(".form-group-input").classList.add("hasError");
        }
        if (currentPhone.closest(".wrapper-inputs__item")) {
          currentPhone
            .closest(".wrapper-inputs__item")
            .classList.add("hasError");
          if (
            currentPhone
              .closest(".wrapper-inputs__item")
              .querySelector(".error-message")
          ) {
            currentPhone
              .closest(".wrapper-inputs__item")
              .querySelector(".error-message").innerHTML =
              window.errors.phone_error;
          }
        }
      } else {
        if (currentPhone.closest(".form-group-input")) {
          currentPhone
            .closest(".form-group-input")
            .classList.remove("hasError");
        }
        if (currentPhone.closest(".wrapper-inputs__item")) {
          currentPhone
            .closest(".wrapper-inputs__item")
            .classList.remove("hasError");
        }
      }
    } else {
      validation = false;
      if (currentPhone.closest(".form-group-input")) {
        currentPhone.closest(".form-group-input").classList.add("hasError");
      }
      if (currentPhone.closest(".wrapper-inputs__item")) {
        currentPhone.closest(".wrapper-inputs__item").classList.add("hasError");
        if (
          currentPhone
            .closest(".wrapper-inputs__item")
            .querySelector(".error-message")
        ) {
          currentPhone
            .closest(".wrapper-inputs__item")
            .querySelector(".error-message").innerHTML =
            window.errors.phone_error;
        }
      }
    }
  } else {
    if (currentPhone.hasAttribute("required")) {
      validation = false;
      if (currentPhone.closest(".form-group-input")) {
        currentPhone.closest(".form-group-input").classList.add("hasError");
      }
      if (currentPhone.closest(".wrapper-inputs__item")) {
        currentPhone.closest(".wrapper-inputs__item").classList.add("hasError");
        if (
          currentPhone
            .closest(".wrapper-inputs__item")
            .querySelector(".error-message")
        ) {
          currentPhone
            .closest(".wrapper-inputs__item")
            .querySelector(".error-message").innerHTML =
            window.errors.phone_error;
        }
      }
    }
  }

  if (professionalFormCheckbox.checked == false) {
    if (allowNewsletterCheckbox.checked != true) {
      validation = false;
      if (allowNewsletterCheckbox.closest(".form-group")) {
        allowNewsletterCheckbox
          .closest(".form-group")
          .classList.add("hasError");
      }
    } else {
      if (allowNewsletterCheckbox.closest(".form-group")) {
        allowNewsletterCheckbox
          .closest(".form-group")
          .classList.remove("hasError");
      }
    }
  } else {
    if (allowNewsletterCheckbox.closest(".form-group")) {
      allowNewsletterCheckbox
        .closest(".form-group")
        .classList.remove("hasError");
    }
  }

  if (professionalFormCheckbox.checked == true) {
    if (currentCompanyName.value == "") {
      validation = false;
      if (currentCompanyName.closest(".form-group-input")) {
        currentCompanyName
          .closest(".form-group-input")
          .classList.add("hasError");
      }
      if (currentCompanyName.closest(".wrapper-inputs__item")) {
        currentCompanyName
          .closest(".wrapper-inputs__item")
          .classList.add("hasError");
        if (
          currentCompanyName
            .closest(".wrapper-inputs__item")
            .querySelector(".error-message")
        ) {
          currentCompanyName
            .closest(".wrapper-inputs__item")
            .querySelector(".error-message").innerHTML =
            window.errors.required_error;
        }
      }
    } else {
      if (currentCompanyName.closest(".form-group-input")) {
        currentCompanyName
          .closest(".form-group-input")
          .classList.remove("hasError");
      }
      if (currentCompanyName.closest(".wrapper-inputs__item")) {
        currentCompanyName
          .closest(".wrapper-inputs__item")
          .classList.remove("hasError");
      }
    }
    if (currentCompanyType.value == "") {
      validation = false;
      if (currentCompanyType.closest(".form-group-input")) {
        currentCompanyType
          .closest(".form-group-input")
          .classList.add("hasError");
      }
      if (currentCompanyType.closest(".wrapper-inputs__item")) {
        currentCompanyType
          .closest(".wrapper-inputs__item")
          .classList.add("hasError");
        if (
          currentCompanyType
            .closest(".wrapper-inputs__item")
            .querySelector(".error-message")
        ) {
          currentCompanyType
            .closest(".wrapper-inputs__item")
            .querySelector(".error-message").innerHTML =
            window.errors.required_error;
        }
      }
    } else {
      if (currentCompanyType.closest(".form-group-input")) {
        currentCompanyType
          .closest(".form-group-input")
          .classList.remove("hasError");
      }
      if (currentCompanyType.closest(".wrapper-inputs__item")) {
        currentCompanyType
          .closest(".wrapper-inputs__item")
          .classList.remove("hasError");
      }
    }
    if (allowProfessionalNewsletterCheckbox.checked != true) {
      validation = false;
      if (allowProfessionalNewsletterCheckbox.closest(".form-group")) {
        allowProfessionalNewsletterCheckbox
          .closest(".form-group")
          .classList.add("hasError");
      }
    } else {
      if (allowProfessionalNewsletterCheckbox.closest(".form-group")) {
        allowProfessionalNewsletterCheckbox
          .closest(".form-group")
          .classList.remove("hasError");
      }
    }
    /*
        if(allowUseDataCheckbox.checked != true){
            validation = false;
            if(allowUseDataCheckbox.closest('.form-group')){
                allowUseDataCheckbox.closest('.form-group').classList.add('hasError')
            }
        }else{
            if(allowUseDataCheckbox.closest('.form-group')){
                allowUseDataCheckbox.closest('.form-group').classList.remove('hasError')
            }
        }
      */
  }
  if (validation) {
    setTimeout(() => {
      newsletterProfessionalAndBaseFormSubmit(form);
    }, 3000);
  } else {
    console.log(false);
  }
}
function newsletterProfessionalAndBaseFormSubmit(form) {
  let currentEmail = form.querySelector('input[name="email"]').value;
  // let currentGender = form.querySelector('select[name="gender"]').value;
  let currentFirstName = form.querySelector('input[name="first_name"]').value;
  let currentLastName = form.querySelector('input[name="last_name"]').value;
  let currentCompanyName = form.querySelector(
    'input[name="company_name"]',
  ).value;
  let currentCompanyType = form.querySelector(
    'select[name="company_type"]',
  ).value;
  let currentPhone = form.querySelector('input[name="phone"]').value;
  let professionalFormCheckbox = form.querySelector(
    'input[name="professional_form"]',
  );
  let customTags =
    form.querySelector('input[name="tags"]')?.value || "newsletter";

  let requestDataStr = "";
  if (professionalFormCheckbox.checked == true) {
    // requestDataStr = `EMAIL=${currentEmail}&MMERGE8=${currentGender}&FNAME=${currentFirstName}&LNAME=${currentLastName}&PHONE=${currentPhone}&MMERGE6=${currentCompanyName}&MMERGE7=${currentCompanyType}&b_e2953e97c82b5390683028c78_25cbd195e3=`
    requestDataStr = `EMAIL=${currentEmail}&FNAME=${currentFirstName}&LNAME=${currentLastName}&PHONE=${currentPhone}&MMERGE6=${currentCompanyName}&MMERGE7=${currentCompanyType}&MMERGE9=${encodeURIComponent(customTags)}&b_e2953e97c82b5390683028c78_25cbd195e3=`;
    mailchimpSend(professionalNewsletterRequestUrl, requestDataStr, form);
    newsletterProfessionalAndBaseFormShopify(form);
  } else {
    // requestDataStr = `EMAIL=${currentEmail}&MMERGE8=${currentGender}&FNAME=${currentFirstName}&LNAME=${currentLastName}&b_e2953e97c82b5390683028c78_25cbd195e3=`
    requestDataStr = `EMAIL=${currentEmail}&FNAME=${currentFirstName}&LNAME=${currentLastName}&MMERGE9=${encodeURIComponent(customTags)}&b_e2953e97c82b5390683028c78_25cbd195e3=`;
    mailchimpSend(baseNewsletterRequestUrl, requestDataStr, form);
    newsletterProfessionalAndBaseFormShopify(form);
  }
}
function newsletterProfessionalAndBaseFormShopify(form) {
  let currentEmail = form.querySelector('input[name="email"]').value;
  // let currentGender = form.querySelector('select[name="gender"]').value;
  let currentFirstName = form.querySelector('input[name="first_name"]').value;
  let currentLastName = form.querySelector('input[name="last_name"]').value;
  let currentCompanyName = form.querySelector(
    'input[name="company_name"]',
  ).value;
  let currentCompanyType = form.querySelector(
    'select[name="company_type"]',
  ).value;
  let professionalFormCheckbox = form.querySelector(
    'input[name="professional_form"]',
  );
  let shopifyBaseForm = document.querySelector(
    '[data-forms-id="forms-root-158454"] shopify-forms-embed',
  );
  let shopifyProfessionalForm = document.querySelector(
    '[data-forms-id="forms-root-158457"] shopify-forms-embed',
  );
  let event = new Event("input");
  if (professionalFormCheckbox.checked == true) {
    if (shopifyProfessionalForm) {
      if (
        shopifyProfessionalForm.shadowRoot.querySelector('input[id="email"]')
      ) {
        shopifyProfessionalForm.shadowRoot.querySelector(
          'input[id="email"]',
        ).value = currentEmail;
        shopifyProfessionalForm.shadowRoot
          .querySelector('input[id="email"]')
          .dispatchEvent(event);
      }
      if (
        shopifyProfessionalForm.shadowRoot.querySelector(
          'input[id="first_name"]',
        )
      ) {
        shopifyProfessionalForm.shadowRoot.querySelector(
          'input[id="first_name"]',
        ).value = currentFirstName;
        shopifyProfessionalForm.shadowRoot
          .querySelector('input[id="first_name"]')
          .dispatchEvent(event);
      }
      if (
        shopifyProfessionalForm.shadowRoot.querySelector(
          'input[id="last_name"]',
        )
      ) {
        shopifyProfessionalForm.shadowRoot.querySelector(
          'input[id="last_name"]',
        ).value = currentLastName;
        shopifyProfessionalForm.shadowRoot
          .querySelector('input[id="last_name"]')
          .dispatchEvent(event);
      }
      // if(shopifyProfessionalForm.shadowRoot.querySelector('input[id="custom#gender"]')){
      //     shopifyProfessionalForm.shadowRoot.querySelector('input[id="custom#gender"]').value = currentGender;
      //     shopifyProfessionalForm.shadowRoot.querySelector('input[id="custom#gender"]').dispatchEvent(event);
      // }
      if (
        shopifyProfessionalForm.shadowRoot.querySelector(
          'input[id="custom#company_name"]',
        )
      ) {
        shopifyProfessionalForm.shadowRoot.querySelector(
          'input[id="custom#company_name"]',
        ).value = currentCompanyName;
        shopifyProfessionalForm.shadowRoot
          .querySelector('input[id="custom#company_name"]')
          .dispatchEvent(event);
      }
      if (
        shopifyProfessionalForm.shadowRoot.querySelector(
          'input[id="custom#company_type"]',
        )
      ) {
        shopifyProfessionalForm.shadowRoot.querySelector(
          'input[id="custom#company_type"]',
        ).value = currentCompanyType;
        shopifyProfessionalForm.shadowRoot
          .querySelector('input[id="custom#company_type"]')
          .dispatchEvent(event);
      }
      if (
        shopifyProfessionalForm.shadowRoot.querySelector(
          'button[type="submit"]',
        )
      ) {
        shopifyProfessionalForm.shadowRoot
          .querySelector('button[type="submit"]')
          .click();
      }
    }
  } else {
    if (shopifyBaseForm) {
      if (shopifyBaseForm.shadowRoot.querySelector('input[id="email"]')) {
        shopifyBaseForm.shadowRoot.querySelector('input[id="email"]').value =
          currentEmail;
        shopifyBaseForm.shadowRoot
          .querySelector('input[id="email"]')
          .dispatchEvent(event);
      }
      if (shopifyBaseForm.shadowRoot.querySelector('input[id="first_name"]')) {
        shopifyBaseForm.shadowRoot.querySelector(
          'input[id="first_name"]',
        ).value = currentFirstName;
        shopifyBaseForm.shadowRoot
          .querySelector('input[id="first_name"]')
          .dispatchEvent(event);
      }
      if (shopifyBaseForm.shadowRoot.querySelector('input[id="last_name"]')) {
        shopifyBaseForm.shadowRoot.querySelector(
          'input[id="last_name"]',
        ).value = currentLastName;
        shopifyBaseForm.shadowRoot
          .querySelector('input[id="last_name"]')
          .dispatchEvent(event);
      }
      // if(shopifyBaseForm.shadowRoot.querySelector('input[id="custom#gender"]')){
      //     shopifyBaseForm.shadowRoot.querySelector('input[id="custom#gender"]').value = currentGender;
      //     shopifyBaseForm.shadowRoot.querySelector('input[id="custom#gender"]').dispatchEvent(event);
      // }
      if (shopifyBaseForm.shadowRoot.querySelector('button[type="submit"]')) {
        shopifyBaseForm.shadowRoot
          .querySelector('button[type="submit"]')
          .click();
      }
    }
  }
}

function newsletterProfessionalFormValidation(form) {
  let currentEmail = form.querySelector('input[name="email"]');
  let currentCompanyName = form.querySelector('input[name="company_name"]');
  let currentCompanyType = form.querySelector('select[name="company_type"]');
  let currentPhone = form.querySelector('input[name="phone"]');
  let allowProfessionalNewsletterCheckbox = form.querySelector(
    'input[name="allow_professional_newsletter"]',
  );
  let allowUseDataCheckbox = form.querySelector('input[name="allow_use_data"]');
  let validation = true;
  if (currentEmail.value == "") {
    validation = false;
    if (currentEmail.closest(".form-group-input")) {
      currentEmail.closest(".form-group-input").classList.add("hasError");
    }
    if (currentEmail.closest(".wrapper-inputs__item")) {
      currentEmail.closest(".wrapper-inputs__item").classList.add("hasError");
      if (
        currentEmail
          .closest(".wrapper-inputs__item")
          .querySelector(".error-message")
      ) {
        currentEmail
          .closest(".wrapper-inputs__item")
          .querySelector(".error-message").innerHTML =
          window.errors.required_error;
      }
    }
  } else {
    if (currentEmail.closest(".form-group-input")) {
      currentEmail.closest(".form-group-input").classList.remove("hasError");
    }
    if (currentEmail.closest(".wrapper-inputs__item")) {
      currentEmail
        .closest(".wrapper-inputs__item")
        .classList.remove("hasError");
    }
  }
  if (validateEmail(currentEmail.value)) {
    if (currentEmail.closest(".form-group-input")) {
      currentEmail.closest(".form-group-input").classList.remove("hasError");
    }
    if (currentEmail.closest(".wrapper-inputs__item")) {
      currentEmail
        .closest(".wrapper-inputs__item")
        .classList.remove("hasError");
    }
  } else {
    validation = false;
    if (currentEmail.closest(".form-group-input")) {
      currentEmail.closest(".form-group-input").classList.add("hasError");
    }
    if (currentEmail.closest(".wrapper-inputs__item")) {
      currentEmail.closest(".wrapper-inputs__item").classList.add("hasError");
      if (
        currentEmail
          .closest(".wrapper-inputs__item")
          .querySelector(".error-message")
      ) {
        currentEmail
          .closest(".wrapper-inputs__item")
          .querySelector(".error-message").innerHTML =
          window.errors.email_error;
      }
    }
  }
  if (currentPhone.value != "") {
    if (validatePhone(currentPhone.value)) {
      if (currentPhone.value.length < 5) {
        validation = false;
        if (currentPhone.closest(".form-group-input")) {
          currentPhone.closest(".form-group-input").classList.add("hasError");
        }
        if (currentPhone.closest(".wrapper-inputs__item")) {
          currentPhone
            .closest(".wrapper-inputs__item")
            .classList.add("hasError");
          if (
            currentPhone
              .closest(".wrapper-inputs__item")
              .querySelector(".error-message")
          ) {
            currentPhone
              .closest(".wrapper-inputs__item")
              .querySelector(".error-message").innerHTML =
              window.errors.phone_error;
          }
        }
      } else {
        if (currentPhone.closest(".form-group-input")) {
          currentPhone
            .closest(".form-group-input")
            .classList.remove("hasError");
        }
        if (currentPhone.closest(".wrapper-inputs__item")) {
          currentPhone
            .closest(".wrapper-inputs__item")
            .classList.remove("hasError");
        }
      }
    } else {
      validation = false;
      if (currentPhone.closest(".form-group-input")) {
        currentPhone.closest(".form-group-input").classList.add("hasError");
      }
      if (currentPhone.closest(".wrapper-inputs__item")) {
        currentPhone.closest(".wrapper-inputs__item").classList.add("hasError");
        if (
          currentPhone
            .closest(".wrapper-inputs__item")
            .querySelector(".error-message")
        ) {
          currentPhone
            .closest(".wrapper-inputs__item")
            .querySelector(".error-message").innerHTML =
            window.errors.phone_error;
        }
      }
    }
  } else {
    if (currentPhone.hasAttribute("required")) {
      validation = false;
      if (currentPhone.closest(".form-group-input")) {
        currentPhone.closest(".form-group-input").classList.add("hasError");
      }
      if (currentPhone.closest(".wrapper-inputs__item")) {
        currentPhone.closest(".wrapper-inputs__item").classList.add("hasError");
        if (
          currentPhone
            .closest(".wrapper-inputs__item")
            .querySelector(".error-message")
        ) {
          currentPhone
            .closest(".wrapper-inputs__item")
            .querySelector(".error-message").innerHTML =
            window.errors.phone_error;
        }
      }
    }
  }

  if (currentCompanyName.value == "") {
    validation = false;
    if (currentCompanyName.closest(".form-group-input")) {
      currentCompanyName.closest(".form-group-input").classList.add("hasError");
    }
    if (currentCompanyName.closest(".wrapper-inputs__item")) {
      currentCompanyName
        .closest(".wrapper-inputs__item")
        .classList.add("hasError");
      if (
        currentCompanyName
          .closest(".wrapper-inputs__item")
          .querySelector(".error-message")
      ) {
        currentCompanyName
          .closest(".wrapper-inputs__item")
          .querySelector(".error-message").innerHTML =
          window.errors.required_error;
      }
    }
  } else {
    if (currentCompanyName.closest(".form-group-input")) {
      currentCompanyName
        .closest(".form-group-input")
        .classList.remove("hasError");
    }
    if (currentCompanyName.closest(".wrapper-inputs__item")) {
      currentCompanyName
        .closest(".wrapper-inputs__item")
        .classList.remove("hasError");
    }
  }
  if (currentCompanyType.value == "") {
    validation = false;
    if (currentCompanyType.closest(".form-group-input")) {
      currentCompanyType.closest(".form-group-input").classList.add("hasError");
    }
    if (currentCompanyType.closest(".wrapper-inputs__item")) {
      currentCompanyType
        .closest(".wrapper-inputs__item")
        .classList.add("hasError");
      if (
        currentCompanyType
          .closest(".wrapper-inputs__item")
          .querySelector(".error-message")
      ) {
        currentCompanyType
          .closest(".wrapper-inputs__item")
          .querySelector(".error-message").innerHTML =
          window.errors.required_error;
      }
    }
  } else {
    if (currentCompanyType.closest(".form-group-input")) {
      currentCompanyType
        .closest(".form-group-input")
        .classList.remove("hasError");
    }
    if (currentCompanyType.closest(".wrapper-inputs__item")) {
      currentCompanyType
        .closest(".wrapper-inputs__item")
        .classList.remove("hasError");
    }
  }
  if (allowProfessionalNewsletterCheckbox.checked != true) {
    validation = false;
    if (allowProfessionalNewsletterCheckbox.closest(".form-group")) {
      allowProfessionalNewsletterCheckbox
        .closest(".form-group")
        .classList.add("hasError");
    }
  } else {
    if (allowProfessionalNewsletterCheckbox.closest(".form-group")) {
      allowProfessionalNewsletterCheckbox
        .closest(".form-group")
        .classList.remove("hasError");
    }
  }
  /*
    if(allowUseDataCheckbox.checked != true){
        validation = false;
        if(allowUseDataCheckbox.closest('.form-group')){
            allowUseDataCheckbox.closest('.form-group').classList.add('hasError')
        }
    }else{
        if(allowUseDataCheckbox.closest('.form-group')){
            allowUseDataCheckbox.closest('.form-group').classList.remove('hasError')
        }
    }
*/
  if (validation) {
    newsletterProfessionalFormSubmit(form);
  } else {
    console.log(false);
  }
}
function newsletterProfessionalFormSubmit(form) {
  let currentEmail = form.querySelector('input[name="email"]').value;
  let currentCompanyName = form.querySelector(
    'input[name="company_name"]',
  ).value;
  let currentCompanyType = form.querySelector(
    'select[name="company_type"]',
  ).value;
  let currentPhone = form.querySelector('input[name="phone"]').value;

  let customTags =
    form.querySelector('input[name="tags"]')?.value || "proffessional";
  let requestDataStr = "";
  requestDataStr = `EMAIL=${currentEmail}&PHONE=${currentPhone}&MMERGE6=${currentCompanyName}&MMERGE7=${currentCompanyType}&MMERGE9=${encodeURIComponent(customTags)}&b_e2953e97c82b5390683028c78_25cbd195e3=`;
  mailchimpSend(professionalNewsletterRequestUrl, requestDataStr, form);
  newsletterProfessionalFormShopify(form);
}
function newsletterProfessionalFormShopify(form) {
  let currentEmail = form.querySelector('input[name="email"]').value;
  let currentCompanyName = form.querySelector(
    'input[name="company_name"]',
  ).value;
  let currentCompanyType = form.querySelector(
    'select[name="company_type"]',
  ).value;

  let shopifyProfessionalForm = document.querySelector(
    '[data-forms-id="forms-root-158457"] shopify-forms-embed',
  );
  let event = new Event("input");

  if (shopifyProfessionalForm) {
    if (shopifyProfessionalForm.shadowRoot.querySelector('input[id="email"]')) {
      shopifyProfessionalForm.shadowRoot.querySelector(
        'input[id="email"]',
      ).value = currentEmail;
      shopifyProfessionalForm.shadowRoot
        .querySelector('input[id="email"]')
        .dispatchEvent(event);
    }

    if (
      shopifyProfessionalForm.shadowRoot.querySelector(
        'input[id="custom#company_name"]',
      )
    ) {
      shopifyProfessionalForm.shadowRoot.querySelector(
        'input[id="custom#company_name"]',
      ).value = currentCompanyName;
      shopifyProfessionalForm.shadowRoot
        .querySelector('input[id="custom#company_name"]')
        .dispatchEvent(event);
    }
    if (
      shopifyProfessionalForm.shadowRoot.querySelector(
        'input[id="custom#company_type"]',
      )
    ) {
      shopifyProfessionalForm.shadowRoot.querySelector(
        'input[id="custom#company_type"]',
      ).value = currentCompanyType;
      shopifyProfessionalForm.shadowRoot
        .querySelector('input[id="custom#company_type"]')
        .dispatchEvent(event);
    }
    if (
      shopifyProfessionalForm.shadowRoot.querySelector('button[type="submit"]')
    ) {
      shopifyProfessionalForm.shadowRoot
        .querySelector('button[type="submit"]')
        .click();
    }
  }
}
// The theme does not load jQuery, so the JSONP request is made without it.
function mailchimpSendJsonp(options) {
  const callback =
    "mailchimpCallback" + Date.now() + Math.random().toString(36).slice(2);
  const script = document.createElement("script");
  const cleanup = () => {
    delete window[callback];
    script.remove();
  };
  window[callback] = (res) => {
    cleanup();
    options.success(res);
  };
  script.onerror = (error) => {
    cleanup();
    options.error(error);
  };
  // c is the callback parameter that makes MailChimp return a JSONP response
  script.src = options.url.replace("c=?", "c=" + callback) + "&" + options.data;
  document.body.appendChild(script);
}
function mailchimpSend(url, data, form) {
  console.log(data);
  mailchimpSendJsonp({
    url: url,
    data: data,
    error: (error) => {
      console.log(error);
      console.log("Error", error);
    },
    success: (res) => {
      console.log(res.result);
      console.log(res.msg);
      if (res.result == "success") {
        form.reset();
        if (form.querySelectorAll("select")) {
          form.querySelectorAll("select").forEach(function (select) {
            if (select.querySelector("option[data-default]")) {
              select
                .querySelector("option[data-default]")
                .removeAttribute("disabled");
              select
                .querySelector("option[data-default]")
                .setAttribute("value", "  ");
              select
                .querySelector("option[data-default]")
                .setAttribute("selected", "selected");
              select
                .querySelector("option[data-default]")
                .setAttribute("disabled", "disabled");
              select.tomselect.sync();
            }
          });
        }
        if (form.closest(".newsletter-form-full")) {
          form
            .closest(".newsletter-form-full")
            .classList.remove("show-additional");
        }
        if (form.querySelector(".js-open-successForm-modal")) {
          form.querySelector(".js-open-successForm-modal").click();
        }
      } else if (res.result == "error") {
        form.reset();
        if (form.querySelectorAll("select")) {
          form.querySelectorAll("select").forEach(function (select) {
            if (select.querySelector("option[data-default]")) {
              select
                .querySelector("option[data-default]")
                .removeAttribute("disabled");
              select
                .querySelector("option[data-default]")
                .setAttribute("value", "  ");
              select
                .querySelector("option[data-default]")
                .setAttribute("selected", "selected");
              select
                .querySelector("option[data-default]")
                .setAttribute("disabled", "disabled");
              select.tomselect.sync();
            }
          });
        }
        if (form.closest(".newsletter-form-full")) {
          form
            .closest(".newsletter-form-full")
            .classList.remove("show-additional");
        }
        if (document.querySelector("#errorFormModal")) {
          if (document.querySelector("#errorFormModal p.description")) {
            document.querySelector("#errorFormModal p.description").innerHTML =
              res.msg;
          }
          if (form.querySelector(".js-open-errorForm-modal")) {
            form.querySelector(".js-open-errorForm-modal").click();
          }
        }
      }
    },
  });
}
document.body.addEventListener("input", function (event) {
  if (event.target.getAttribute("type") == "checkbox") {
    if (event.target.closest(".wrapper-inputs__item")) {
      event.target
        .closest(".wrapper-inputs__item")
        .classList.remove("hasErrorСheckbox");
    }
  } else {
    if (event.target.closest(".form-group-input")) {
      event.target.closest(".form-group-input").classList.remove("hasError");
    }
    if (event.target.closest(".wrapper-inputs__item")) {
      event.target
        .closest(".wrapper-inputs__item")
        .classList.remove("hasError");
    }
    if (event.target.closest(".form-group")) {
      event.target.closest(".form-group").classList.remove("hasError");
    }
  }
});
document.body.addEventListener("change", function (event) {
  if (event.target.getAttribute("type") == "checkbox") {
    if (event.target.closest(".wrapper-inputs__item")) {
      event.target
        .closest(".wrapper-inputs__item")
        .classList.remove("hasErrorСheckbox");
    }
  } else {
    if (event.target.closest(".form-group-input")) {
      event.target.closest(".form-group-input").classList.remove("hasError");
    }
    if (event.target.closest(".wrapper-inputs__item")) {
      event.target
        .closest(".wrapper-inputs__item")
        .classList.remove("hasError");
    }
    if (event.target.closest(".form-group")) {
      event.target.closest(".form-group").classList.remove("hasError");
    }
  }
});
